/* unplugin-vue-components disabled */import { render } from "./VideoSearch.vue?vue&type=template&id=145a03fc&scoped=true"
import script from "./VideoSearch.vue?vue&type=script&lang=js"
export * from "./VideoSearch.vue?vue&type=script&lang=js"

import "./VideoSearch.vue?vue&type=style&index=0&id=145a03fc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145a03fc"]])

export default __exports__